import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { connect, useDispatch, useSelector } from "react-redux";

import * as ActionType from "../../store/hostRequest/hostRequest.type";
import { hostRequestUpdate } from "../../store/hostRequest/hostRequest.action";
import noImage from "../../assets/img/female.png";

const HostRequestEdit = (props) => {
  const { dialog: open, dialogData } = useSelector((state) => state.hostRequest);
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [bio, setBio] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [country, setCountry] = useState("");
  const [image, setImage] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [video, setVideo] = useState(null);
  const [videoPath, setVideoPath] = useState("");
  const [error, setError] = useState({});

  useEffect(() => {
    if (dialogData) {
      setName(dialogData?.name || "");
      setEmail(dialogData?.email || "");
      setCountry(dialogData?.country || "");
      setAge(dialogData?.age ?? "");
      setGender(dialogData?.gender || "");
      setBio(dialogData?.bio || "");
      setImagePath(dialogData?.image || "");
      setVideoPath(dialogData?.video || "");
      setImage(null);
      setVideo(null);
      setError({});
    }
  }, [dialogData]);

  const handleClose = () => dispatch({ type: ActionType.CLOSE_HOST_REQUEST_DIALOG });

  const handleImage = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setImage(f);
    setImagePath(URL.createObjectURL(f));
    setError((p) => ({ ...p, image: "" }));
  };

  const handleVideo = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setVideo(f);
    setVideoPath(URL.createObjectURL(f));
  };

  const handleSubmit = () => {
    const err = {};
    if (!name) err.name = "İsim zorunlu";
    if (!email) err.email = "E-posta zorunlu";
    if (!bio) err.bio = "Biyografi zorunlu";
    if (!gender) err.gender = "Cinsiyet seçilmeli";
    if (!age) err.age = "Yaş zorunlu";
    else if (Number(age) < 18) err.age = "Yaş 18'den küçük olamaz";
    if (!country) err.country = "Ülke zorunlu";
    if (!imagePath) err.image = "Görsel zorunlu";
    // video artik istege bagli: basvuruda da zorunlu degil

    if (Object.keys(err).length) return setError(err);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("age", age);
    formData.append("country", country);
    if (image) formData.append("image", image);
    if (video) formData.append("video", video);
    formData.append("email", email);
    formData.append("gender", gender);
    formData.append("bio", bio);

    props.hostRequestUpdate(formData, dialogData._id);
    handleClose();
  };

  const onKey = (e) => {
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") handleSubmit();
  };

  const S = styles;

  const Field = ({ label, children, err, full }) => (
    <div style={{ ...S.field, ...(full ? { gridColumn: "1 / -1" } : {}) }}>
      <label style={S.label}>{label}</label>
      {children}
      {err && <div style={S.err}>{err}</div>}
    </div>
  );

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ style: S.paper }}>
      <div style={S.head}>
        <div>
          <div style={S.title}>Başvuruyu düzenle</div>
          <div style={S.sub}>{dialogData?.name}</div>
        </div>
        <button type="button" style={S.close} onClick={handleClose} aria-label="Kapat">
          ×
        </button>
      </div>

      <DialogContent style={S.body}>
        <div style={S.grid} onKeyDown={onKey}>
          <Field label="İsim" err={error.name}>
            <input style={S.input} value={name} onChange={(e) => setName(e.target.value)} placeholder="İsim" />
          </Field>

          <Field label="E-posta" err={error.email}>
            <input style={S.input} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta" />
          </Field>

          <Field label="Biyografi" err={error.bio} full>
            <textarea
              style={{ ...S.input, height: 72, resize: "vertical" }}
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              placeholder="Kısa tanıtım"
            />
          </Field>

          <Field label="Yaş" err={error.age}>
            <input style={S.input} type="number" value={age} onChange={(e) => setAge(e.target.value)} placeholder="18" />
          </Field>

          <Field label="Ülke" err={error.country}>
            <input style={S.input} value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Ülke" />
          </Field>

          <Field label="Cinsiyet" err={error.gender} full>
            <div style={S.radios}>
              {[
                ["Male", "Erkek"],
                ["Female", "Kadın"],
              ].map(([val, txt]) => (
                <button
                  key={val}
                  type="button"
                  style={{ ...S.radio, ...(gender === val ? S.radioOn : {}) }}
                  onClick={() => setGender(val)}
                >
                  {txt}
                </button>
              ))}
            </div>
          </Field>

          <Field label="Profil görseli" err={error.image}>
            <div style={S.mediaBox}>
              <img
                src={imagePath || noImage}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                alt=""
                style={S.profileImg}
              />
              <label style={S.fileBtn}>
                Görsel seç
                <input type="file" accept="image/*" onChange={handleImage} style={{ display: "none" }} />
              </label>
            </div>
          </Field>

          <Field label="Tanıtım videosu (isteğe bağlı)">
            <div style={S.mediaBox}>
              {videoPath ? (
                <video src={videoPath} style={S.video} controls />
              ) : (
                <div style={S.noVideo}>Video yok</div>
              )}
              <label style={S.fileBtn}>
                Video seç
                <input type="file" accept="video/*" onChange={handleVideo} style={{ display: "none" }} />
              </label>
            </div>
          </Field>
        </div>
      </DialogContent>

      <div style={S.foot}>
        <button type="button" style={{ ...S.btn, ...S.btnGhost }} onClick={handleClose}>
          Vazgeç
        </button>
        <button type="button" style={{ ...S.btn, ...S.btnPrimary }} onClick={handleSubmit}>
          Kaydet
        </button>
      </div>
    </Dialog>
  );
};

const styles = {
  paper: { borderRadius: 16, background: "#fff" },
  head: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "20px 22px 12px",
    borderBottom: "1px solid #eef1f6",
    background: "#fff",
  },
  title: { fontSize: 18, fontWeight: 700, color: "#1b2334" },
  sub: { fontSize: 13, color: "#8b93a7", marginTop: 2 },
  close: {
    border: "none",
    background: "#f2f4f8",
    color: "#5b6478",
    width: 32,
    height: 32,
    borderRadius: 8,
    fontSize: 20,
    lineHeight: "20px",
    cursor: "pointer",
  },
  body: { padding: "18px 22px", background: "#fff" },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 },
  field: { display: "flex", flexDirection: "column", minWidth: 0 },
  label: { fontSize: 12.5, fontWeight: 600, color: "#42506b", marginBottom: 6 },
  input: {
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "10px 12px",
    fontSize: 14,
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    background: "#fff",
  },
  err: { color: "#b42318", fontSize: 12, marginTop: 4 },
  radios: { display: "flex", gap: 8 },
  radio: {
    border: "1px solid #dde2ec",
    background: "#fff",
    color: "#42506b",
    borderRadius: 10,
    padding: "9px 22px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  radioOn: { background: "#4361ee", borderColor: "#4361ee", color: "#fff" },
  mediaBox: { display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-start" },
  profileImg: { width: 92, height: 92, borderRadius: 12, objectFit: "cover", background: "#f2f4f8" },
  video: { width: 140, height: 92, borderRadius: 12, objectFit: "cover", background: "#0b1020" },
  noVideo: {
    width: 140,
    height: 92,
    borderRadius: 12,
    background: "#f2f4f8",
    color: "#9aa3b8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
  },
  fileBtn: {
    border: "1px solid #dde2ec",
    borderRadius: 10,
    padding: "8px 14px",
    fontSize: 13.5,
    fontWeight: 600,
    color: "#42506b",
    cursor: "pointer",
    background: "#fff",
  },
  foot: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    padding: "14px 22px 20px",
    borderTop: "1px solid #eef1f6",
    background: "#fff",
  },
  btn: {
    border: "1px solid transparent",
    borderRadius: 10,
    padding: "9px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
  },
  btnGhost: { background: "#fff", borderColor: "#dde2ec", color: "#42506b" },
  btnPrimary: { background: "#4361ee", color: "#fff" },
};

export default connect(null, { hostRequestUpdate })(HostRequestEdit);
